import { useMemo } from 'react';
import { COMMON_TIMEZONES, otherTimezones } from '../lib/timezones';
import { Select } from './ui';

/**
 * Picks an IANA time zone by the name a person would say.
 *
 * The regions we cover sit in their own group at the top; the rest of the
 * world follows, so an account in Sao Paulo is still one scroll away. A value
 * that came from elsewhere — the CSV loader, a zone this browser has never
 * heard of — is kept as its own option rather than silently reset to the
 * default, which would rewrite the record on the next save.
 */
export function TimezoneSelect({
  value,
  onChange,
  id,
}: {
  value: string;
  onChange: (zone: string) => void;
  id?: string;
}) {
  const others = useMemo(otherTimezones, []);
  const known = COMMON_TIMEZONES.some((t) => t.zone === value) || others.includes(value);

  return (
    <Select id={id} value={value} onChange={(event) => onChange(event.target.value)}>
      {!known && value && <option value={value}>{value}</option>}
      <optgroup label="Where we work">
        {COMMON_TIMEZONES.map((t) => (
          <option key={t.zone} value={t.zone}>
            {t.label}
          </option>
        ))}
      </optgroup>
      {others.length > 0 && (
        <optgroup label="All time zones">
          {others.map((zone) => (
            <option key={zone} value={zone}>
              {zone.replace(/_/g, ' ')}
            </option>
          ))}
        </optgroup>
      )}
    </Select>
  );
}
